import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {borderRadius, flex, flexAlignCenter, mb, mr, mt, onDesktop, p, textAlign} from "@pg-design/helpers-css";
import {BrandCrownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IRankingListBanner {
    handleGetMoreInfoClick: () => void;
    name_declension_where?: string;
}

export const RankingListBanner = (props: IRankingListBanner) => {
    const theme = useTheme();

    const copyTextCss = [textAlign("center"), onDesktop(textAlign("left"))];

    return (
        <div css={rankingListBannerWrapper}>
            <BrandCrownIcon css={icon} size="8" wrapperColor={theme.colors.primary} wrapperSize="8" />

            <div css={copy}>
                <Text css={copyTextCss} as="h1" variant="headline_3" fontFamily="secondary" mb={1}>
                    Ranking najlepszych inwestycji {props.name_declension_where}
                </Text>

                <Button variant="filled_primary" size="x-small" onClick={props.handleGetMoreInfoClick}>
                    Dowiedz się więcej o rankingu
                </Button>
            </div>
        </div>
    );
};

const rankingListBannerWrapper = (theme: Theme) => css`
    background-color: ${theme.colors.success};
    ${borderRadius(2)};
    ${p(3)};
    ${mt(3)};
    ${mb(4)};
    ${flex("center")};
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.sm}) {
        ${p(3, 6)};
        flex-direction: row;
    }
`;

const copy = (theme: Theme) => css`
    ${flexAlignCenter};
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.sm}) {
        ${flex("flex-start")};
    }
`;

const icon = (theme: Theme) => css`
    ${mb(3)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${mr(4)};
        ${mb(0)};
    }
`;
import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {borderRadius, flex, flexAlignCenter, mb, mr, mt, onDesktop, p, textAlign} from "@pg-design/helpers-css";
import {BrandCrownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IRankingListBanner {
    handleGetMoreInfoClick: () => void;
    name_declension_where?: string;
}

export const RankingListBanner = (props: IRankingListBanner) => {
    const theme = useTheme();

    const copyTextCss = [textAlign("center"), onDesktop(textAlign("left"))];

    return (
        <div css={rankingListBannerWrapper}>
            <BrandCrownIcon css={icon} size="8" wrapperColor={theme.colors.primary} wrapperSize="8" />

            <div css={copy}>
                <Text css={copyTextCss} as="h1" variant="headline_3" fontFamily="secondary" mb={1}>
                    Ranking najlepszych inwestycji {props.name_declension_where}
                </Text>

                <Button variant="filled_primary" size="x-small" onClick={props.handleGetMoreInfoClick}>
                    Dowiedz się więcej o rankingu
                </Button>
            </div>
        </div>
    );
};

const rankingListBannerWrapper = (theme: Theme) => css`
    background-color: ${theme.colors.success};
    ${borderRadius(2)};
    ${p(3)};
    ${mt(3)};
    ${mb(4)};
    ${flex("center")};
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.sm}) {
        ${p(3, 6)};
        flex-direction: row;
    }
`;

const copy = (theme: Theme) => css`
    ${flexAlignCenter};
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.sm}) {
        ${flex("flex-start")};
    }
`;

const icon = (theme: Theme) => css`
    ${mb(3)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${mr(4)};
        ${mb(0)};
    }
`;
